module.exports = __webpack_public_path__ + "img/progress-bar-edge.a429dd84.png";